const AboutPage = () => {
  return (
    <div className="page-container about-page-container">
      <section className="who-we-are">
        <div className="section-header-line">
          <h2>who we are</h2> <hr />{" "}
        </div>
        <div className="content-container">
          <div className="text-section">
            <p>
              Away Home Zone Ltd is a London based property company, comprised
              of a dedicated team, devoted to generating a profitable outcome
              for all the stakeholders, thereby creating a win- win situation;
              the Landlords, estate Agents, Contractors, holiday makers, other
              corporate clients, while also meeting the needs of our various
              guests. We are reliable and trustworthy partners in short lets.
              Furthermore, our property experience, knowledge base and team of
              professionals around us equip us to execute and advise on the
              different property strategies and also handle every property
              related challenge.
            </p>
          </div>
          <div className="img-container">
            <img src="https://d3ca8k3fzbwwwf.cloudfront.net/whoWeAre.webp" alt="who we are" />
          </div>
        </div>
      </section>
      <section className="why-we-started">
        <div className="section-header-line">
          <h2>why we started</h2> <hr />
        </div>
        <div className="content-container" id="whydnt">
          <div className="images-container">
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/why1.webp" alt="why" />
            </div>
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/why2.webp" alt="why" />
            </div>
            <div className="img-container" id="third-why">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/why3.webp" alt="why" />
            </div>
          </div>
          <div className="text-container">
            <p>
              London is a multicultural society and one of the most famous
              cities in the world. As a result, millions of tourists visit the
              city every year to see the various landmarks. Being also a
              cosmopolitan urban city and headquarter to different
              organizations, various construction and development projects are
              carried out every year. This in turn attracts contractors,
              professionals, businessmen, etc. to the city. These people require
              short term stays and many prefer alternative accommodation to the
              hotels for more comfort, flexibility and privacy. Hence the
              ever-growing demand for the short lets outweighs the current
              supply, thereby creating a market gap. Consequently, Away Home
              Zone Ltd started with the aim of filling this market gap by
              providing the short-term letting service that remains in high
              demand.
            </p>
          </div>
        </div>

        <div className="content-container" id="whym">
          <p>
            London is a multicultural society and one of the most famous cities
            in the world. As a result, millions of tourists visit the city every
            year to see the various landmarks. Being also a cosmopolitan urban
            city and headquarter to different organizations, various
            construction and development projects are carried out every year.
            This in turn attracts contractors, professionals, businessmen, etc.
            to the city.
          </p>
          <div className="img-container">
            <img src="https://d3ca8k3fzbwwwf.cloudfront.net/why2.webp" alt="why" />
          </div>
          <p>
            These people require short term stays and many prefer alternative
            accommodation to the hotels for more comfort, flexibility and
            privacy. Hence the ever-growing demand for the short lets outweighs
            the current supply, thereby creating a market gap. Consequently,
            Away Home Zone Ltd started with the aim of filling this market gap
            by providing the short-term letting service that remains in high
            demand.
          </p>
        </div>
      </section>

      <section className="what-we-offer" id="what-we-offer">
        <div className="section-header-line">
          <h2>what we offer</h2> <hr />
        </div>

        <div className="content-container" id="desktop-offers">
          <div className="offer">
            <h3>to Landlords</h3>
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/landlords.webp" alt="landlords" />
            </div>
            <div className="text-container">
              <p>
                We help Landlords manage their properties, eliminate voids, and
                offer them guaranteed rent. We ensure that properties are well
                looked after as we are committed to providing excellent
                accommodations or our guests.
              </p>
            </div>
          </div>
          <div className="offer">
            <h3>to guests</h3>
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/guests.webp" alt="guests" />
            </div>
            <div className="text-container">
              <p>
                As a reliable partner in short-term letting, we are committed to
                providing affordable, suitable, comfortable and fully insured
                accommodations that meet the specific needs of our clients,
                making them feel at home while away from home.
              </p>
            </div>
          </div>
          <div className="offer">
            <h3>to Agents</h3>
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/agents.webp" alt="agents" />
            </div>
            <div className="text-container">
              <p>
                We partner with the Agents and not taking over their jobs,
                offering them the opportunity to let their suitable properties
                as soon as they are available, thereby helping them to get their
                commissions promptly without delay.
              </p>
            </div>
          </div>
        </div>

        <div className="content-container" id="tablet-offers">
          <div className="offer">
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/landlords.webp" alt="landlords" />
            </div>

            <div className="text-container">
              <h3>to Landlords</h3>
              <p>
                We help Landlords manage their properties, eliminate voids, and
                offer them guaranteed rent. We ensure that properties are well
                looked after as we are committed to providing excellent
                accommodations or our guests.
              </p>
            </div>
          </div>
          <div className="offer">
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/guests.webp" alt="guests" />
            </div>
            <div className="text-container">
              <h3>to guests</h3>
              <p>
                As a reliable partner in short-term letting, we are committed to
                providing affordable, suitable, comfortable and fully insured
                accommodations that meet the specific needs of our clients,
                making them feel at home while away from home.
              </p>
            </div>
          </div>
          <div className="offer">
            <div className="img-container">
              <img src="https://d3ca8k3fzbwwwf.cloudfront.net/agents.webp" alt="agents" />
            </div>
            <div className="text-container">
              <h3>to Agents</h3>
              <p>
                We partner with the Agents and not taking over their jobs,
                offering them the opportunity to let their suitable properties
                as soon as they are available, thereby helping them to get their
                commissions promptly without delay.
              </p>
            </div>
          </div>
        </div>

        <div className="content-container" id="mobile-offers">
          <div className="offer">
            <div className="img-and-title">
              <div className="img-container">
                <img src="https://d3ca8k3fzbwwwf.cloudfront.net/landlords.webp" alt="landlords" />
              </div>
              <h3>to Landlords</h3>
            </div>
            <div className="text-container">
              <p>
                We help Landlords manage their properties, eliminate voids, and
                offer them guaranteed rent. We ensure that properties are well
                looked after as we are committed to providing excellent
                accommodations or our guests.
              </p>
            </div>
          </div>
          <div className="offer">
            <div className="img-and-title">
              <div className="img-container">
                <img src="https://d3ca8k3fzbwwwf.cloudfront.net/guests.webp" alt="guests" />
              </div>
              <h3>to guests</h3>
            </div>
            <div className="text-container">
              <p>
                As a reliable partner in short-term letting, we are committed to
                providing affordable, suitable, comfortable and fully insured
                accommodations that meet the specific needs of our clients,
                making them feel at home while away from home.
              </p>
            </div>
          </div>
          <div className="offer">
            <div className="img-and-title">
              <div className="img-container">
                <img src="https://d3ca8k3fzbwwwf.cloudfront.net/agents.webp" alt="agents" />
              </div>
              <h3>to Agents</h3>
            </div>
            <div className="text-container">
              <p>
                We partner with the Agents and not taking over their jobs,
                offering them the opportunity to let their suitable properties
                as soon as they are available, thereby helping them to get their
                commissions promptly without delay.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
